import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

import FMPHeadline from '../../components/ui/FMPHeadline';
import RebateCampaignsContainer from '../../containers/rebateCampaigns/RebateCampaigns';
import EnhancedTableHead from '../../components/EnhancedTableHead';
import { isFiltered, sortTable } from '../../libs/utility';

import { getSharedStyles } from '../../themes';
const styles = (theme) => ({
	...getSharedStyles(theme),
	button: {
		verticalAlign: 'middle',
		padding: '8px 10px',
	},
	stats: {
		padding: '20px 10px 20px 10px',
		borderBottom: '1px solid #ddd',
		marginBottom: 10,
	},
	statGroup: {
		padding: '5px 5px 10px 5px',
		borderBottom: '1px solid #eee',
		marginBottom: 10,
	},
	available: {
		fontWeight: 900,
	},
});

//const columnStyle = { whiteSpace : 'nowrap' };
const columnData = [
	{ id: 'id', label: 'Campaign ID', padding: 'checkbox' },
	{ id: 'name', label: 'Campaign Name', padding: 'checkbox' },
	{ id: 'stationCount', label: 'Station Count', padding: 'checkbox' },
	{ id: 'createdByUserDisplay', padding: 'checkbox', label: 'Created By' },
	{ id: 'edit', numeric: false, label: 'Edit' },
];

class RebateCampaigns extends Component {
	constructor(props) {
		super(props);
		this.state = {
			order: 'desc',
			orderBy: 'name',
			search: '',
		};
	}

	componentDidMount() {
		if (!this.props.rebateCampaigns.length) {
			this.props.rebateCampaignSearch();
		}
	}

	handleSearch = (event) => {
		this.setState({ search: event.target.value });
	};

	handleRequestSort = (orderBy) => {
		let order = 'desc';
		if (this.state.orderBy === orderBy && this.state.order === 'desc') {
			order = 'asc';
		}
		this.setState({ order, orderBy });
	};

	handleEdit = (rebateCampaignId) => {
		this.props.history.push(`/rebateCampaign/update/${rebateCampaignId}`);
	};

	render() {
		const { classes, rebateCampaigns, canMakeUpdates, userMap } = this.props;

		const { order, orderBy, search } = this.state;

		if (!rebateCampaigns) {
			return <div>Loading the rebate campaigns ...</div>;
		}
		let rows = rebateCampaigns.reduce((result, rebateCampaign) => {
			const { rebateCampaignId, name, stationIds, createdByUserId } = rebateCampaign;

			const stationCount = stationIds.length;

			const user = userMap[createdByUserId] || {
				firstName: 'Missing',
				lastName: '',
			};
			const createdByUserDisplay = `${user.firstName} ${user.lastName}`;

			const row = {
				rebateCampaignId,
				name,
				stationCount,
				createdByUserDisplay,
			};

			if (isFiltered({ search, data: row, fields: ['name'] })) {
				return result;
			}
			result.push(row);
			return result;
		}, []);
		rows = sortTable({ data: rows, order, orderBy });

		return (
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<FMPHeadline
						label="Rebate Campaigns"
						value={this.state.search}
						onChange={this.handleSearch}
						url="/rebateCampaign/add"
						buttonText="ADD REBATE CAMPAIGN"
						canMakeUpdates={false}
					/>

					<Paper className={classes.paper}>
						<Table stickyHeader size="small" className={classes.table}>
							<EnhancedTableHead
								columnData={columnData}
								order={order}
								orderBy={orderBy}
								onRequestSort={this.handleRequestSort}
							/>
							<TableBody>
								{rows.map((row) => {
									return (
										<TableRow hover className={classes.row} key={row.rebateCampaignId}>
											<TableCell>{row.rebateCampaignId}</TableCell>
											<TableCell>{row.name}</TableCell>
											<TableCell>{row.stationCount}</TableCell>
											<TableCell>{row.createdByUserDisplay}</TableCell>

											{canMakeUpdates && (
												<TableCell style={{ whiteSpace: 'nowrap' }}>
													<Button
														className={classes.button}
														onClick={() => this.handleEdit(row.rebateCampaignId)}
													>
														Edit
													</Button>
												</TableCell>
											)}
										</TableRow>
									);
								})}
							</TableBody>
						</Table>
					</Paper>
				</Grid>
			</Grid>
		);
	}
}

RebateCampaigns.propTypes = {
	classes: PropTypes.object.isRequired,
	rebateCampaignSearch: PropTypes.func.isRequired,
	rebateCampaigns: PropTypes.array,
	stationMap: PropTypes.object,
	userMap: PropTypes.object,

	showErrors: PropTypes.func.isRequired,

	order: PropTypes.string,
	orderBy: PropTypes.string,
	history: PropTypes.object,

	canMakeUpdates: PropTypes.bool,
};

export default _.flow([withStyles(styles), RebateCampaignsContainer])(RebateCampaigns);
